export const AdminHeader = ({ eyebrow, title, description, actions, testid, className = "mb-8" }) => (
  <div data-testid={testid} className={`${className} flex flex-wrap items-end justify-between gap-4 pb-6 border-b border-[#E5DED5]`.trim()}>
    <div className="min-w-0">
      {eyebrow && <p className="text-[10px] font-ui tracking-[0.3em] uppercase text-[#C71E2E] font-semibold">{eyebrow}</p>}
      <h1 className="mt-1.5 font-display text-3xl tracking-tight text-[#1A1A1A]">{title}</h1>
      {description && <p className="mt-1.5 text-sm font-ui text-[#4A4A4A] max-w-2xl leading-relaxed">{description}</p>}
    </div>
    {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
  </div>
);
